<template>
  <div>
    <div class="mt-4 mb-4">
      <form @submit.prevent="submit" @keydown="form.onKeydown($event)">
        <div class="row bg-white">
          <div class="col-md-12 col-lg-4 mt-n4 mt-md-0">
            <div class="form-group">
              <label for="titre"
                >Titre <span class="text-danger">*</span></label
              >
              <input
                class="form-control"
                :class="{
                  'is-invalid': form.errors.has('titre'),
                }"
                id="titre"
                v-model="form.titre"
                type="text"
                placeholder="Titre de la mission"
                maxlength="100"
                required
              />
              <has-error :form="form" field="titre"></has-error>
            </div>
          </div>

          <div class="col-md-6 col-lg-4 mt-n4 mt-md-0">
            <div class="form-group">
              <label for="date_debut"
                >Date début <span class="text-danger">*</span></label
              >
              <date-picker
                v-model="form.date_debut"
                name="date_debut"
                placeholder="Date début"
                lang="fr"
                format="DD/MM/YYYY"
                value-type="DD/MM/YYYY"
                @close="setDateFin"
              ></date-picker>
              <input
                class="form-control"
                :class="{
                  'is-invalid': form.errors.has('date_debut'),
                }"
                type="hidden"
              />
              <has-error :form="form" field="date_debut"></has-error>
            </div>
          </div>

          <div class="col-md-6 col-lg-4 mt-n4 mt-md-0">
            <div class="form-group">
              <label for="date_fin"
                >Date fin <span class="text-danger">*</span></label
              >
              <date-picker
                v-model="form.date_fin"
                name="date_fin"
                placeholder="Date fin"
                lang="fr"
                format="DD/MM/YYYY"
                value-type="DD/MM/YYYY"
                required
              ></date-picker>
              <input
                class="form-control"
                :class="{
                  'is-invalid': form.errors.has('date_fin'),
                }"
                type="hidden"
              />
              <has-error :form="form" field="date_fin"></has-error>
            </div>
          </div>
        </div>
        <div class="row mt-4">
          <div class="w-100 mt-2">
            <b-card
              class="text-black"
              header-class="bg-silver border-bottom-0"
              no-body
            >
              <template #header>
                <div>
                  <h5 class="font-size-16 mb-0">
                    <i class="mr-1" :class="icons.ICON_DESCRIPTION"></i>
                    Description
                  </h5>
                </div>
              </template>
              <div class="row editor">
                <div class="col-md-12">
                  <vue-editor
                    id="description"
                    v-model="form.description"
                    :editorToolbar="VueEditorToolbar"
                    class="fonction-mission"
                  />
                </div>
              </div>
            </b-card>
          </div>
        </div>
        <div class="row mt-4 mb-4">
          <div class="col-md-12 text-right">
            <ButtonLoader
              :busy="form.busy"
              type="submit"
              customClass="btn btn-custom-primary w-40"
              loadText="Traitement en cours..."
              Text="Enregistrer"
              style="min-width: 100px"
            ></ButtonLoader>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import URL from '@/http/crm/mission/mission';
import DatePicker from 'vue2-datepicker';

import { VueEditor } from 'vue2-editor';
import VueEditorToolbar from '@/vue-editor-tool-bar';
import moment from 'moment';
import icons from '@/icons/crm/mission';

import From from 'vform';
export default {
  data() {
    return {
      form: new From({
        titre: '',
        date_debut: this.$options.filters.formatDate(new Date(), 'DD/MM/YYYY'),
        date_fin: '',
        description: '',
      }),
      VueEditorToolbar,
      icons,
    };
  },
  components: {
    DatePicker,
    VueEditor,
  },
  metaInfo() {
    return {
      title: this.title,
      titleTemplate: this.titleApp + ' | %s',
    };
  },
  methods: {
    submit() {
      this.form
        .put(URL.MISSION + '/' + this.id)
        .then((resp) => {
          this.showSimpleAlerte('top-end', 'success', resp.data.message);

          this.form.reset();
          this.form.clear();
          this.init();
        })
        .catch(() => {});
    },
    setDateFin() {
      if (!this.form.date_fin) {
        if (this.form.date_debut) {
          this.form.date_fin = moment(this.form.date_debut, 'DD/MM/YYYY')
            .add(7, 'days')
            .format('DD/MM/YYYY');
        }
      }
    },

    init() {
      this.id = this.$route.params.id;

      window.axios
        .all([window.axios.get(URL.MISSION + '/' + this.id)])
        .then(
          window.axios.spread((resp) => {
            Object.assign(this.form, resp.data.mission);
          })
        )
        .catch();
    },
  },
  mounted() {
    this.init();
  },
};
</script>

<style scoped></style>
